import React from "react";
import { motion } from "framer-motion";
import { FloralDivider } from "@/components/Ornaments";

const CouplePhotos = ({ data }) => {
  const { photos, names, date } = data;
  return (
    <section data-testid="couple-photos" className="space-y-8 text-center">
      <FloralDivider className="opacity-80" />
      <div className="relative mx-auto h-[330px] w-full max-w-[340px] sm:h-[370px]">
        <motion.div
          data-testid="couple-photo-left"
          className="absolute left-0 top-10 w-[32%] max-w-[120px] -rotate-[9deg] border border-[#F0E5EA] bg-white p-2 pb-4 shadow-[0_18px_36px_-14px_rgba(28,25,23,0.22)]"
          initial={{ opacity: 0, x: -30, rotate: -20 }}
          whileInView={{ opacity: 1, x: 0, rotate: -9 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7 }}
        >
          <div className="aspect-[3/4] w-full overflow-hidden border border-[#F2E9EE] bg-[#FAF5F7]">
            <img alt={`${names.one} და ${names.two}`} className="h-full w-full object-cover" loading="lazy" src={photos.left} />
          </div>
        </motion.div>

        <motion.div
          data-testid="couple-photo-right"
          className="absolute right-0 top-14 w-[32%] max-w-[120px] rotate-[8deg] border border-[#F0E5EA] bg-white p-2 pb-4 shadow-[0_18px_36px_-14px_rgba(28,25,23,0.22)]"
          initial={{ opacity: 0, x: 30, rotate: 20 }}
          whileInView={{ opacity: 1, x: 0, rotate: 8 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7 }}
        >
          <div className="aspect-[3/4] w-full overflow-hidden border border-[#F2E9EE] bg-[#FAF5F7]">
            <img alt={`${names.one} და ${names.two}`} className="h-full w-full object-cover" loading="lazy" src={photos.right} />
          </div>
        </motion.div>

        <motion.div
          className="absolute left-1/2 top-0 z-10 w-[58%] max-w-[210px] -translate-x-1/2"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <div className="-rotate-2 border border-[#F0E5EA] bg-white p-2.5 pb-6 shadow-[0_26px_50px_-18px_rgba(28,25,23,0.25)] transition-transform duration-500 hover:rotate-0">
            <p className="font-display pb-2 text-center text-[9px] uppercase tracking-[0.35em] text-[#A1A1AA]">
              {date.dotted}
            </p>
            <div className="aspect-[3/4] w-full overflow-hidden border border-[#F2E9EE] bg-[#FAF5F7]">
              <img alt={`${names.one} და ${names.two}`} className="h-full w-full object-cover" src={photos.main} style={{ objectPosition: "center 30%" }} />
            </div>
          </div>
          <div data-testid="couple-heart-tag" className="absolute -bottom-5 right-1 rotate-[7deg]">
            <div className="relative h-[92px] w-[96px]">
              <svg viewBox="0 0 100 96" className="h-full w-full drop-shadow-[0_10px_18px_rgba(28,25,23,0.16)]" aria-hidden="true">
                <path d="M50 90 C22 64 5 45 5 27 C5 13 15 5 27 5 C37 5 45 11 50 21 C55 11 63 5 73 5 C85 5 95 13 95 27 C95 45 78 64 50 90 Z" fill="#FFFFFF" stroke="#E0C2CE" strokeWidth="1" />
                <circle cx="50" cy="9" r="2" fill="none" stroke="#C98BA0" strokeWidth="0.9" />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-[1px] pb-3 leading-tight">
                <span className="font-sans-geo text-[9.5px] font-light tracking-[0.1em] text-[#6B6560]">{names.one}</span>
                <span className="font-script text-[13px] leading-none text-[#B0607A]">&amp;</span>
                <span className="font-sans-geo text-[9.5px] font-light tracking-[0.1em] text-[#6B6560]">{names.two}</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CouplePhotos;
